import React from "react";
import ReactPlayer from "react-player";

export default function VideoPlayer({ video, onPosition, onDuration, onPlay, onPause, onEnded }) {
  return <div className="player-wrapper relative aspect-video w-full overflow-hidden rounded-card">
    <ReactPlayer url={video} width="100%" height="100%" controls
      progressInterval={1000} onProgress={({ playedSeconds }) => onPosition?.(playedSeconds)}
      onDuration={onDuration} onPlay={onPlay} onPause={onPause} onEnded={onEnded} />
  </div>;
}
